import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
} from '@occc-app/design-system';

import { TransactionViewItemData, TransactionViewItemOptionalColumns } from './types';
import { TransactionViewItem } from './TransactionViewItem';
import { TransactionViewSavingItem } from './TransactionViewSavingItem';

type Props = {
  items: TransactionViewItemData[];
  hideColumns?: TransactionViewItemOptionalColumns[];
};

export const TransactionViewItems = (props: Props) => {
  const { items, hideColumns = [] } = props;

  return (
    <TableContainer
      sx={(theme) => ({
        marginBottom: theme.spacing(1),
      })}
    >
      <TableHeader title='Items Purchased' />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Item</TableCell>
            {!hideColumns.includes('group') && <TableCell>Line Item Group</TableCell>}
            {!hideColumns.includes('sku') && <TableCell>SKU</TableCell>}
            {!hideColumns.includes('upc') && <TableCell>UPC</TableCell>}
            <TableCell align='right'>Quantity</TableCell>
            <TableCell align='right'>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TransactionViewItem key={item.id} item={item} hideColumns={hideColumns}>
              {item.savings?.length ? <TransactionViewSavingItem savings={item.savings} /> : null}
            </TransactionViewItem>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
